const AUTH_PROVIDER_DISPLAY_NAMES: Record<string, string> = {
  yandex: 'Yandex',
  credentials: 'электронная почта и пароль',
};

const AUTH_PROVIDER_VIA_LABELS: Record<string, string> = {
  yandex: 'Yandex',
  credentials: 'электронную почту и пароль',
};

const TURNSTILE_ERROR_MESSAGES: Record<string, string> = {
  'Captcha not configured': 'Антиспам-проверка сейчас недоступна. Попробуйте позже.',
  'Captcha not ready': 'Проверка Turnstile еще загружается. Подождите немного и попробуйте снова.',
  'Captcha timed out': 'Время ожидания проверки Turnstile истекло. Попробуйте еще раз.',
  'Captcha expired': 'Срок действия проверки Turnstile истек. Запустите ее еще раз.',
  'Captcha failed': 'Не удалось пройти антиспам-проверку. Попробуйте еще раз.',
};

const DEFAULT_PROVIDER_DISPLAY_NAME = 'внешний провайдер';
const DEFAULT_PROVIDER_VIA_LABEL = 'внешнего провайдера';
const DEFAULT_TURNSTILE_ERROR_MESSAGE = 'Не удалось пройти антиспам-проверку. Попробуйте еще раз.';

export function getAuthProviderDisplayName(provider?: string | null): string {
  if (!provider) {
    return DEFAULT_PROVIDER_DISPLAY_NAME;
  }

  return AUTH_PROVIDER_DISPLAY_NAMES[provider] ?? DEFAULT_PROVIDER_DISPLAY_NAME;
}

export function getAuthProviderViaLabel(provider?: string | null): string {
  if (!provider) {
    return DEFAULT_PROVIDER_VIA_LABEL;
  }

  return AUTH_PROVIDER_VIA_LABELS[provider] ?? DEFAULT_PROVIDER_VIA_LABEL;
}

export function getTurnstileErrorMessage(error: unknown): string {
  if (!(error instanceof Error) || !error.message) {
    return DEFAULT_TURNSTILE_ERROR_MESSAGE;
  }

  return TURNSTILE_ERROR_MESSAGES[error.message] ?? DEFAULT_TURNSTILE_ERROR_MESSAGE;
}
